/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { useCreateDocumentWidgetLocalization } from '../api/documentWidgets';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import useToastNotification from './useToastNotification';

export const useWidgetLocalization = (handleDrawerClose, selectedWidget) => {
  const { t } = useTranslation();
  const { mutate, isSuccess, isLoading, isError } = useCreateDocumentWidgetLocalization();

  const schema = yup
    .object()
    .shape({
      subtitle: yup.string().required(t('NameRequired')),
      title: yup.string().required(t('TitleRequired')),
      language: yup.string().required(t('languageRequired')),
    })
    .required();

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    register,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      defaultValues: {
        subtitle: '',
        title: '',
        language: '',
      },
    },
    resolver: yupResolver(schema),
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    reset({
      subtitle: '',
      title: '',
      language: '',
    });
  }, [reset]);

  useToastNotification({
    isShow: isSuccess,
    loading: isLoading,
    messageKey: 'successLocalizationDocumentWidget',
    variant: 'success',
  });

  useToastNotification({
    isShow: isError,
    loading: isLoading,
    messageKey: 'errorLocalizationDocumentWidget',
    variant: 'error',
  });

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append('subtitle', data.subtitle);
    formData.append('title', data.title);
    formData.append('language', data.language);
    formData.append('widget', selectedWidget);

    mutate({ data: formData });
    reset();
    handleDrawerClose();
  };

  return {
    handleSubmit,
    control,
    onSubmit,
    isLoading,
    errors,
    register,
  };
};
